const hostsList = [
    {
        host: 'omsk.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 71612329,
        }],
    },
    {
        host: 'tlt.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 57288301,
        }],
    },
    {
        host: 'izh.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 57288685,
        }],
    },
    {
        host: 'kazan2.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 84843022,
        }],
    },
    {
        host: 'yakutsk.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 76122562,
        }],
    },
    {
        host: 'mkala.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 86042921,
        }],
    },
    {
        host: 'chelny.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 82012768,
        }],
    },
    {
        host: 'almet.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 89554325,
        }],
    },
    {
        host: 'tula.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 85998515,
        }],
    },
    {
        host: 'ekb.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 86820109,
        }],
    },
    {
        host: 'kem.varikozanet',
        metrika: [{
            goalPrefix: 'sk_',
            ymID: 86858462,
        }],
    },
    {
        host: 'kazan.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 65907064,
        },
            {
                path: /\/promo/,
                goalPrefix: '',
                ymID: 90953415,
            }],
    },
    {
        host: 'nkz.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 87549320,
        }],
    },
    {
        host: 'samara.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 84837802,
        }],
    },
    {
        host: 'ryazan.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 83224939,
        }],
    },
    {
        host: 'yar.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 74799688,
        }],
    },
    {
        host: 'rostov.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 70588120,
        },
            {
                path: /\/promo/,
                goalPrefix: '',
                ymID: 91375604,
            }],
    },
    {
        host: 'abakan.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 56834686,
        }],
    },
    {
        host: 'irkutsk.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 51250222,
        }],
    },
    {
        host: 'sochi.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 90759743,
        }],
    },
    {
        host: 'tomsk.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 93429449,
        }],
    },
    {
        host: 'kirov.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 94600085,
        }],
    },
    {
        host: 'khab.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 95702512,
        }],
    },
    {
        host: 'sterlitamak.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 98363421,
        }],
    },
    {
        host: 'nvartovsk.varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 99506676,
        }],
    },
    {
        host: 'varikozanet',
        metrika: [{
            goalPrefix: '',
            ymID: 51250102,
        }],
    },
]



const goalsList = [
    {
        goal: ["klik-po-knopke-zapisat'sya-na-priem"],
        selector: '[data-goal="appointment-new-form-header"]'
    },
    {
        goal: ['1_shag_klik_po_knopke_zapisatsya_na_priem', "1-shag-klik-po-knopke-zapisatsya-na-priem"],
        selector: "[data-goal='appointment-new-form-header']"
    },
    {
        goal: ["perekhod-na-stranicu-vybrat'-specialista-i-vremya"],
        selector: ''
    },
    {
        goal: ["klik-po-knopke-vybrat'-specialista-i-vremya"],
        selector: '[data-goal="appointment-choice-specialist"]'
    },
    {
        goal: ["uspeshnaya-otpravka-formy-zapisat'sya-na-priem"],
        selector: ''
    },
    {
        goal: ["klik-po-knopke-zapisatsya"],
        selector: '[data-goal="appointment-new-form-specialist"]'
    },
    {
        goal: ['finalnyj_shag_klik_po_knopke_perezvonite_mne', 'otpravka-klik-po-knopke-perezvonite-mne', 'otpravka-nomera-perezvonite-mne', 'sajt-otpravka-formy'],
        selector: "[data-goal='qa-form-link-popup']"
    },
    {
        goal: ['klik_po_nomeru_telefona_v_shapke_sajta', 'klik-po-nomeru-telefona', 'klik-po-nomeram-telefona', 'klik-po-nomeru'],
        selector: "[data-goal='tel-link-header']"
    },
    {
        goal: ['klik-po-nomeru-telefona', 'klik-po-nomeram-telefona'],
        selector: "[data-goal='tel-link-callback-form']"
    },
    {
        goal: ['otpravka_zayavki_na_obratnyj_zvonok'],
        selector: "[data-goal='callback-form-submit-button']"
    },
    {
        goal: ['klik_po_nomeru_telefona_v_futere', 'klik-po-nomeru-telefona', 'klik-po-nomeram-telefona'],
        selector: "[data-goal='tel-link-footer']"
    },
    {
        goal: ['otpravka_voprosa_vrachu', 'otpravka-voprosa-vrachu', 'sajt-otpravka-formy'],
        selector: "[data-goal='qa-form-button']"
    },
    {
        goal: ['1_shag_klik_po_knopke_zapisatsya_na_priem_v_forme_dlya_zapisi', '1-shag-klik-po-knopke-zapisatsya-na-priem-v-forme-dlya-zapisi', '2-shag-klik-po-knopke-zapisatsya-na-priem-v-forme-dlya-zapisi'],
        selector: "[data-goal='doc-or-date-choice-button']"
    },
    {
        goal: ['2_shag_klik_po_knopke_podtverdit_v_forme_dlya_zapisi', '2-shag-klik-po-knopke-podtverdit-v-forme-dlya-zapisi', '3-shag-klik-po-knopke-podtverdit-v-forme-dlya-zapisi'],
        selector: "[data-goal='appointment-form-confirm-button']"
    },
    {
        goal: ['finalnyj_shag_klik_po_knopke_zapisatsya_v_forme_dlya_zapisi', 'otpravka-klik-po-knopke-zapisatsya-v-forme-dlya-zapisi'],
        selector: "[data-goal='appointment-form-record-button']"
    },
    {
        goal: ['otpravka-klik-po-knopke-zapisatsya-v-forme-dlya-zapisi'],
        selector: ".step-personal .mt-0.mt-sm-5.white--text.v-btn.v-btn--has-bg"
    },
    {
        goal: ['1_shag_klik_po_knopke_obratnaya_svyaz_v_futere'],
        selector: "[data-goal='feedback-form-footer']"
    },
    {
        goal: ['finalnyj_shag_klik_po_knopke_otpravit_obratnuyu_svyaz'],
        selector: "[data-goal='feedback-form-footer-submit']"
    },
    {
        goal: ['svyazatsya-s-menedzherom-1-shag', 'svyazatsya-s-menedzherom-1-shag', '1-shag-svyazatsya-s-menedzherom'],
        selector: "[data-goal='callback-button-header']"
    },
    {
        goal: ['svyazatsya-s-menedzherom-otpravka', 'finalnyj-shag-svyazatsya-s-menedzherom-otpravka'],
        selector: ""
    },
    {
        goal: ['otpravka-zayavki-na-obratnyj-zvonok'],
        selector: ""
    },
    {
        goal: ['lending-otpravka-formy'],
        selector: ""
    },
    {
        goal: ['otpravka-formy'],
        selector: ""
    },
    {
        goal: ['klik-po-nomeru'],
        selector: "[data-goal='click-phone']"
    },
    {
        goal: ['sajt-otpravka-formy'],
        selector: "[data-goal='send-form']"
    },
    {
        goal: ['klik-po-znachkam-messendzherov'],
        selector: "[data-goal='click-socials-links']"
    },
    {
        goal: ['svyz'],
        selector: "[data-goal='click-submit-landing-callback']"
    },
    {
        goal: ['zapis_na_priem'],
        selector: "[data-goal='click-submit-landing-appointment']"
    },
    {
        goal: ['ostavit_zayvku'],
        selector: "[data-goal='click-submit-landing-submit-your-application']"
    },
    {
        goal: ['zapisytsy_na_konsultaciu'],
        selector: "[data-goal='click-submit-landing-signup-a-consultation']"
    },
    {
        goal: ['podarok'],
        selector: "[data-goal='click-submit-landing-promo']"
    },
]

var activeCity = null

function dispatchGoalEvent(goal, data = {}) {
    window.dispatchEvent(new CustomEvent('ajax-form-complete', {
        detail: {
            ...data,
            ym: {
                goal: goal
            }
        }
    }))
}

document.addEventListener('DOMContentLoaded', function () {
    activeCity = identifyCity()
    if (!activeCity) return

    function initGoalsListener() {
        document.addEventListener('click', goalsHandler)
    }

    function goalsHandler(e) {
        const goal = goalsList.find(function (item) {
            return item.selector && e.target.closest(item.selector)
        })
        if (goal) {
            sendGoal(goal.goal)
        }
    }

    function sendGoal(goals) {
        if (typeof ym === "undefined") return

        activeCity.metrika.forEach(metrikaItem => {
            if (checkPath(metrikaItem))
                goals.forEach(function (goal) {
                    ym(metrikaItem.ymID, 'reachGoal', metrikaItem.goalPrefix + goal)
                })
        })
    }

    function checkPath(metrikaItem) {
        if (!metrikaItem.path)
            return true
        return metrikaItem.path.test(location.pathname)
    }

    function identifyCity() {
        const domain = getDomain(window.location.host);
        var cityData = null
        for (var i = 0; i < hostsList.length; i++) {
            if (domain === hostsList[i].host) {
                cityData = hostsList[i]
                cityData.index = i
                return cityData
            }
        }
        return cityData
    }
    initGoalsListener()

    window.addEventListener('ajax-form-complete', function (e) {
        if (e.detail.ym && e.detail.ym.goal) {
            const sendGoalData = Array.isArray(e.detail.ym.goal) ? e.detail.ym.goal : [e.detail.ym.goal]

            sendGoal(sendGoalData)
        }
    })

    window.addEventListener('load', () => {
        const pageGoal = document.querySelectorAll('[data-page-goal]');
        pageGoal.forEach((page) => {
            sendGoal([page.getAttribute('data-page-goal')]);
        });
    });
})

function getDomain(host) {
    var domainParts = host.split('.');

    domainParts = domainParts.slice(0, domainParts.length-1)

    return domainParts.join('.');
}
